import { ReactNode } from "react";
import styles from "./Subheading.module.css";

const Subheading = ({ children }: { children: ReactNode }) => (
  <h3 className={styles.subheading}>{children}</h3>
);

export default Subheading;
